export default __webpack_public_path__ + "static/media/favicon.153d1666.png";